import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";

const NegativeRegisteryMasterCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { authToken } = useSelector((state) => state.login.authData);

  // ---------------- STATES ----------------
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);

  const [panApplicantNumber, setPanApplicantNumber] = useState("");
  const [panApplicantNumberState, setPanApplicantNumberState] =
    useState(false);

  const [aadharNumber, setAadharNumber] = useState("");
  const [aadharNumberState, setAadharNumberState] = useState(false);

  const [reason, setReason] = useState("");
  const [risk, setRisk] = useState(false);

  const [disabledButton, setDisabledButton] = useState(true);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");

  const [callInProgress, setCallInProgress] = useState(false);
  const [mobileNumber, setMobileNumber]=useState("");
  const [mobileNumberState, setMobileNumberState]=useState(false)

  // ---------------- LOAD DATA ----------------
  useEffect(() => {
    (async () => {
      if (params.id) {
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.NEGATIVE_REGISTERY_FINDALL ,
          authToken,
        });
        setCallInProgress(false);
        if(!result?.data?.error_code && result?.data?.length > 0){
          const filteredData = result?.data?.filter((item)=> item?.id === Number(params?.id)) || [];
        const data = filteredData?.[0] || {}
        setName(data?.customerName || "");
        setPanApplicantNumber(data?.pan || "");
        setAadharNumber(data?.adhaar || "");
        setReason(data?.reason || "");
        setMobileNumber(data?.mobileNumber || "")
        setRisk(data?.risk || false);
        }
      }
    })();
  }, [params.id]);

  // ---------------- BUTTON ENABLE LOGIC ----------------
  useEffect(() => {
    const panFilled = panApplicantNumber?.trim();
    const aadharFilled = aadharNumber?.trim();
    const mobileNumberFilled = mobileNumber?.trim();

    if (
      name?.trim() &&
      reason?.trim() &&
      (panFilled || aadharFilled || mobileNumberFilled)
    ) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [name, reason, risk, panApplicantNumber, aadharNumber, mobileNumber]);

  // ---------------- VALIDATION ----------------
  const isValidated = () => {
    let valid = true;

    // Name mandatory
    if (!name?.trim()) {
      setNameState(true);
      valid = false;
    } else {
      setNameState(false);
    }

    // Remarks mandatory
    if (!reason?.trim()) {
      showError("Remarks is mandatory");
      valid = false;
    }

    const panFilled = panApplicantNumber?.trim();
    const aadharFilled = aadharNumber?.trim();

    // At least one required
    if (!panFilled && !aadharFilled && mobileNumber?.length !== 10) {
      showError("Either PAN or Aadhar is mandatory");
      valid = false;
    }

    // PAN validation (if filled)
    if (panFilled) {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!panRegex.test(panApplicantNumber.toUpperCase())) {
        setPanApplicantNumberState(true);
        showError("Invalid PAN format");
        valid = false;
      } else {
        setPanApplicantNumberState(false);
      }
    }

    // Aadhar validation (if filled)
    if (aadharFilled) {
      const aadharRegex = /^[0-9]{12}$/;
      if (!aadharRegex.test(aadharNumber)) {
        setAadharNumberState(true);
        showError("Invalid Aadhar format");
        valid = false;
      } else {
        setAadharNumberState(false);
      }
    }

    if(mobileNumber){
      if (mobileNumber?.length < 10) {
        setMobileNumberState(true);
        showError("Invalid Mobile Number");
        valid = false;
      } else {
        setMobileNumberState(false);
      }
    }
    return valid;
  };

  const showError = (message) => {
    setToastMessageType("Error");
    setToastMessage(message);
    setToast(true);
  };

  // ---------------- API CALLS ----------------
  const saveOrUpdate = async () => {
    const url = params.id
      ? endpoint.NEGATIVE_REGISTERY_UPDATE + params.id
      : endpoint.NEGATIVE_REGISTERY_ADD;

    const method = params.id ? "POST" : "POST";

    setCallInProgress(true);
    const res = await apiHandler({
      url,
      method,
      authToken,
      data: {
        customerName: name,
        pan: panApplicantNumber ? panApplicantNumber?.toUpperCase() : null,
        adhaar:aadharNumber ? aadharNumber : null,
        reason:reason,
        mobileNumber:mobileNumber ? mobileNumber : null,
        risk,
      },
    });
    setCallInProgress(false);

    return res;
  };

  // ---------------- SUBMIT ----------------
  const handleSubmit = async () => {
    if (!isValidated()) return;

    const res = await saveOrUpdate();

    if (res?.data?.error_code) {
      showError(res?.data?.user_description);
      return;
    }

    setToastMessageType("Success");
    setToastMessage(
      params.id
        ? "Negative Registry updated successfully!"
        : "Negative Registry created successfully!"
    );
    setToast(true);
    setRedirectURL("/coreservice/NegativeRegistery");
  };

  const toastUpdate = () => {
    setToast(false);
    if (redirectURL) navigate(redirectURL);
  };

  const handleCancel = () => {
    navigate("/coreservice/NegativeRegistery");
  };

  // ---------------- UI ----------------
  return (
    <Grid container>
      <Grid item xs={12}>
        <SubHeader
          label={
            params.id ? "Edit Negative Registry" : "Create Negative Registry"
          }
          button1="Save"
          button2=" Cancel"
          button1click={handleSubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>

      <Grid item xs={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          {/* Name */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Name"
              required
              error={nameState}
              value={name}
              setState={setName}
              setError={setNameState}
              disabled={params.id}
            />
          </Grid>

          {/* PAN */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="PAN No."
              error={panApplicantNumberState}
              value={panApplicantNumber?.toUpperCase()}
              setState={setPanApplicantNumber}
              setError={setPanApplicantNumberState}
              maxLength="10"
              disabled={params.id}
            />
          </Grid>

          {/* Aadhar */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Aadhar No"
              error={aadharNumberState}
              value={aadharNumber}
              setState={setAadharNumber}
              setError={setAadharNumberState}
              maxLength="12"
              disabled={params.id}
            />
          </Grid>

            {/* Mobile Number */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Mobile No"
              error={mobileNumberState}
              value={mobileNumber}
              setState={setMobileNumber}
              setError={setMobileNumberState}
              maxLength="10"
              disabled={params.id}
            />
          </Grid>


          {/* Remarks */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <textarea
              placeholder="Reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{ width: "100%", borderRadius: "5px" }}
            />
          </Grid>

          {/* Risk */}
          <Grid item xs={12} sm={6} md={6} className={classes.fieldContaienr}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                fontSize: "16px",
              }}
            >
              <input
                type="checkbox"
                style={{ width: "22px", height: "22px" }}
                checked={risk}
                onChange={(e) => setRisk(e.target.checked)}
              />
              Risk
            </span>
          </Grid>
        </Grid>
      </Grid>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress />}
    </Grid>
  );
};

export default NegativeRegisteryMasterCreate;